import mmvDataReducer from "./reducer";
import saga from "./saga";

export default function mmvDataModule() {
  return {
    id: "mmvDataReducer",
    reducerMap: {
      mmvDataReducer
    },
    sagas: [saga]
  };
}
